// extracted by mini-css-extract-plugin
export default {"root":"CircleLoader_root__tvR+x","circleLoader":"CircleLoader_circleLoader__5f7xN","loader-spin":"CircleLoader_loader-spin__9gNxG"};